module.exports = __webpack_public_path__ + "California-native-garden.jpg?7bb1648fa7230689cc9ef83b19a6acfc";


//////////////////
// WEBPACK FOOTER
// ./src/images/California-native-garden.jpg
// module id = 143
// module chunks = 0